/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_BoldInputs */

const en_tables_custom_properties_bold = /** @type {(inputs: Tables_Custom_Properties_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Bold`)
};

const de_tables_custom_properties_bold = /** @type {(inputs: Tables_Custom_Properties_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Properties Bold" |
*
* @param {Tables_Custom_Properties_BoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_bold = /** @type {((inputs?: Tables_Custom_Properties_BoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_BoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_bold(inputs)
	return de_tables_custom_properties_bold(inputs)
});